module.exports = __webpack_public_path__ + "img/card-rp-global-bills-report.208937a7.svg";